<template>
  <div v-cloak id="app" :style="'background-color: ' + bgColor">
    <htmlStyle v-if="false">
      .primary-fill { fill: {{ colors.primary }}; } .primary-opacity-fill {fill:
      {{ colors.primaryOpacity }};} .primary-stroke {stroke:{{ colors.primary }}
      }
    </htmlStyle>
    <template v-if="!this.$store.getters.getUserRemoveRequestedAt">
      <status-nav v-cloak v-if="displayStatusNavInCurrentRoute"></status-nav>
    </template>
    <template v-else>
      <div class="alert-user-deleted alert alert-danger" role="alert">
        <div class="container">
          <div class="row">
            <div class="col-md-10">
              <b>Il tuo account non sarà più attivo</b>
              dalle ore 23:59 del giorno
              {{
                moment(this.$store.getters.getUserRemoveRequestedAt).format(
                  "DD/MM/YYYY"
                )
              }}
            </div>
            <div class="col-md-2">
              <button class="btn btn-sm btn-primary" @click="undoRemoval">
                RIATTIVA
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <navigation v-cloak v-if="displayNavigationInCurrentRoute"></navigation>
    <router-view />
    <footer-component
      v-cloak
      v-if="['info', '404'].indexOf(this.$route.name) == -1"
    ></footer-component>
    <message-center></message-center>
    <div v-cloak v-if="showSpinner" class="pulse-container">
      <!-- <div>
        <loader
          :loading="showSpinner"
          :color="spinnerColor"
          size="60px"
        ></loader>
      </div>-->
      <lottie-player
        autoplay
        background="transparent"
        loop
        speed="1"
        src="https://assets2.lottiefiles.com/packages/lf20_aunIxG.json"
        style="width: 300px; height: 300px;"
      ></lottie-player>
      <!-- <div class="loader" v-if="showSpinner">
        <div class="v-bounce v-bounce1" style="height: 60px; width: 60px; position: relative;">
          <div
            class="v-bounce v-bounce2"
            :style="'background-color: '+ $store.state.campaign.css_settings.primary +'; height: 60px; width: 60px; border-radius: 100%; opacity: 0.6; position: absolute; top: 0px; left: 0px;'"
          ></div>
          <div
            class="v-bounce v-bounce3"
            :style="'background-color: '+$store.state.campaign.css_settings.primary +'; height: 60px; width: 60px; border-radius: 100%; opacity: 0.6; position: absolute; top: 0px; left: 0px;'"
          ></div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import Navigation from "./components/rebuild/Navigation/NavigationContainer";
import FooterComponent from "./components/FooterLogin";
import MessageCenter from "./components/Campaign/MessageCenter/MessageCenter";
import StatusNav from "./components/StatusNav";
import htmlStyle from "./components/rebuild/common/htmlStyle";
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      loading: true,
      bgColor: null
    };
  },
  components: {
    Navigation,
    FooterComponent,
    MessageCenter,
    StatusNav,
    htmlStyle
  },
  computed: {
    ...mapGetters(["colors"]),
    showSpinner() {
      return this.$store.state.spinnerVisible;
    },
    displayStatusNavInCurrentRoute() {
      if (
        [
          "access",
          "login",
          "index",
          "agreements",
          "socialLogin",
          "info",
          "404",
          "complete-profile"
        ].indexOf(this.$route.name) !== -1
      ) {
        return false;
      } else if (this.$route.name === "dashboard" && this.$mq !== "sm") {
        return false;
      } else if (
        ["instantwin", "survey"].indexOf(this.$route.name) !== -1 &&
        this.$store.getters.isMobile
      ) {
        return false;
      }

      return true;
    },
    displayNavigationInCurrentRoute() {
      if (
        [
          "access",
          "login",
          "index",
          "agreements",
          "info",
          "404",
          "complete-profile"
        ].indexOf(this.$route.name) === -1
      ) {
        return true;
      }

      return false;
    },
    spinnerColor() {
      return _.get(
        this.$store,
        "state.campaign.css_settings.primary",
        "#5F21E0"
      );
    }
  },
  updated() {
    this.bgColor = this.$store.state.campaign.css_settings["body-bg"];
  },
  created() {
    if (this.$messaging) {
      this.$messaging.onTokenRefresh(() => {
        this.$messaging
          .getToken()
          .then(refreshedToken => {
            this.pushDeviceInfo(refreshedToken, "web-firebase");
          })
          .catch(err => {
            console.log("Unable to retrieve refreshed token ", err);
          });

        this.$messaging.onMessage(payload => {
          const notificationTitle = payload.title;
          const notificationOptions = {
            body: payload.body,
            icon: "/favicon.ico"
          };

          return self.registration.showNotification(
            notificationTitle,
            notificationOptions
          );
        });
      });
    }

    if (window.innerWidth <= 767) {
      this.$store.commit("setMobile", true);
      this.$store.commit("setTablet", false);
      this.$store.commit("setDesktop", false);
    } else if (window.innerWidth <= 992) {
      this.$store.commit("setMobile", false);
      this.$store.commit("setTablet", true);
      this.$store.commit("setDesktop", false);
    } else {
      this.$store.commit("setMobile", false);
      this.$store.commit("setTablet", false);
      this.$store.commit("setDesktop", true);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth <= 767) {
        //condtition added to not dispatching to store each time when window is resized
        if (this.$store.getters.isMobile) {
          return;
        }
        this.$store.commit("setMobile", true);
        this.$store.commit("setTablet", false);
        this.$store.commit("setDesktop", false);
      } else if (window.innerWidth <= 992) {
        if (!this.$store.getters.isMobile && this.$store.getters.isTablet) {
          return;
        }
        this.$store.commit("setMobile", false);
        this.$store.commit("setTablet", true);
        this.$store.commit("setDesktop", false);
      } else {
        //condtition added to not dispatching to store each time when window is resized
        if (!this.$store.getters.isMobile && !this.$store.getters.isTablet) {
          return;
        }
        this.$store.commit("setMobile", false);
        this.$store.commit("setTablet", false);
        this.$store.commit("setDesktop", true);
      }
    });

    //remove it when there would be main colors from response
    function getStyle(className) {
      var el = document.createElement("div");
      el.classList.add(className);
      document.body.append(el);
      return getComputedStyle(el).backgroundColor;
    }

    setTimeout(() => {
      const primary = getStyle("btn-primary");
      const primaryOpacity = primary
        .replace(")", ", 0.14)")
        .replace("rgb", "rgba");
      this.$store.commit("updateColors", { primary, primaryOpacity });
      this.bgColor = this.$store.state.campaign.css_settings["body-bg"];
    }, 1000);
  },
  methods: {
    async undoRemoval() {
      this.$store.commit("showSpinner");
      try {
        await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/undelete"
        );

        this.$store.commit("updateUserRemoveRequestedAt", null);
        await this.$store.dispatch("getUnreadMessages");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    }
  }
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
